export default __webpack_public_path__ + "img/gift.06d6db4.svg";